import * as React from "react";
import "../ui.css";
import { useDataUiTheme } from "../utility/getDataUiTheme";
var RadixTabsContext = React.createContext(null);
var useRadixTabsContext = function () {
    var context = React.useContext(RadixTabsContext);
    if (!context) {
        throw new Error("RadixTabs components must be used within RadixTabs.");
    }
    return context;
};
export var RadixTabs = function (_a) {
    var value = _a.value, onValueChange = _a.onValueChange, children = _a.children, className = _a.className;
    var idBaseRef = React.useRef("radix-tabs-".concat(Math.random().toString(36).slice(2, 10)));
    return (React.createElement(RadixTabsContext.Provider, { value: {
            value: value,
            onValueChange: onValueChange,
            idBase: idBaseRef.current,
        } },
        React.createElement("div", { className: ["radix-tabs", className].filter(Boolean).join(" ") }, children)));
};
export var RadixTabsList = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "Tabs" : _b;
    var uiTheme = useDataUiTheme();
    return (React.createElement("div", { className: ["radix-tabs-list", className].filter(Boolean).join(" "), role: "tablist", "aria-label": ariaLabel, "data-ui-theme": uiTheme }, children));
};
export var RadixTabsTrigger = function (_a) {
    var value = _a.value, children = _a.children, className = _a.className, activeClassName = _a.activeClassName, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = useRadixTabsContext(), selectedValue = _c.value, onValueChange = _c.onValueChange, idBase = _c.idBase;
    var isActive = selectedValue === value;
    var triggerId = "".concat(idBase, "-tab-").concat(value);
    var contentId = "".concat(idBase, "-panel-").concat(value);
    return (React.createElement("button", { type: "button", role: "tab", id: triggerId, className: ["radix-tabs-trigger", className, isActive ? "radix-tabs-trigger--active" : "", isActive ? activeClassName : ""].filter(Boolean).join(" "), "aria-selected": isActive, "aria-controls": contentId, disabled: disabled, onClick: function () { return onValueChange(value); } }, children));
};
export var RadixTabsContent = function (_a) {
    var value = _a.value, children = _a.children, className = _a.className;
    var _b = useRadixTabsContext(), selectedValue = _b.value, idBase = _b.idBase;
    var isActive = selectedValue === value;
    var triggerId = "".concat(idBase, "-tab-").concat(value);
    var contentId = "".concat(idBase, "-panel-").concat(value);
    return (React.createElement("div", { role: "tabpanel", id: contentId, "aria-labelledby": triggerId, hidden: !isActive, className: ["radix-tabs-content", className].filter(Boolean).join(" ") }, isActive ? children : null));
};
